export default __webpack_public_path__ + "static/media/EastSettlementofDinogMap.ffddce46.jpg";